export const INITIAL_VALUES = {
  lingua: '',
  nivel: '',
}
